/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://qaduw3fhyzcolnrjqazgtdtc5q.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-yyoexr3pofg6ppaztntme5t76q",
    "aws_cognito_identity_pool_id": "us-west-2:6d6eeb9d-5a07-484f-bb1e-cc3384c34d13",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_0f5bb14PE",
    "aws_user_pools_web_client_id": "1cb25bbnpilk4hjkt2hbtqf885",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
